"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.IJsonInstaller = void 0;
class IJsonInstaller {
    constructor(eventStream, vscodeAccessor) {
        this.eventStream = eventStream;
        this.vscodeAccessor = vscodeAccessor;
    }
}
exports.IJsonInstaller = IJsonInstaller;
//# sourceMappingURL=IJsonInstaller.js.map